import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { FooterTerms } from './components/footer-terms';
import { WordOfDaySection } from '../word-of-day-section';
import { FooterNavLinks } from './components/footer-nav-links';
import { WordOfDaySkeleton } from './components/skeletons/word-of-day-skeleton';

import { IFooterProps } from './model';
import { FooterContainer } from './styles';

export const Footer = ({ termOfDay, loading = false }: IFooterProps) => {
  return (
    <>
      {termOfDay && (
        <ConditionalFooter termOfDay={termOfDay} loading={loading} />
      )}
      <Box displayPrint="none">
        <FooterContainer sx={{ pt: 8, pb: 4 }}>
          <Container maxWidth={false}>
            <FooterNavLinks />
            <FooterTerms />
          </Container>
        </FooterContainer>
      </Box>
    </>
  );
};

const ConditionalFooter = ({ termOfDay, loading = false }: IFooterProps) => {
  if (loading) {
    return <WordOfDaySkeleton />;
  }

  if (termOfDay) {
    return <WordOfDaySection terms={termOfDay} />;
  }

  return null;
};
